<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
  [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">
  <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>
  <kendo-textbox-container class="form-element app multiselect-checkbox">
    <div class="form-label mandatory">
      <label>{{labelName | localizeLabel}}</label>
    </div>

    <div class="form-input-container">
      <ng-container *ngFor="let option of selectableOptions; index as i">

        <boi-validation-error [propertyNames]="[rootPropertyName + '_' + i + '.' + codePropertyName]">
        </boi-validation-error>
        <div class="details__field d-flex my-15">
          <input [disabled]="isFieldDisabled" kendoCheckbox type="checkbox" [id]="rootPropertyName + '_' + 'option' + option.Code"
            [(ngModel)]="option.Selected" (ngModelChange)="updateCheckbox(option)" #formCheckBox class="k-checkbox" />
          <label class="k-checkbox-label ml-15" [for]="rootPropertyName + '_' + 'option' + option.Code" [innerHtml]="option.Value"></label>
        </div>

        <ng-container *ngIf="option.Selected && option.AreDetailsRequired">
          <div #detailField class="form-element app details-container vo-nested-textarea-error">
            <boi-validation-error class="bo-display-none"
              [propertyNames]="[rootPropertyName + '_' + getOptionIndex(option) + '.' + detailsPropertyName]"
              (errorChange)="$event ? detailField.classList.add('has-errors') : detailField.classList.remove('has-errors')">
            </boi-validation-error>
            <div class="form-label mandatory my-15 vo-detailed-field-label">
              <label [innerHtml]="detailsLabelName | localizeLabel"></label>
            </div>

            <div class="form-input-container pb-15 vo-detailed-field-container">
              <boi-validation-error class="vo-display-none"
                [propertyNames]="[rootPropertyName + '_' + getOptionIndex(option) + '.' + detailsPropertyName]">
              </boi-validation-error>
              <textarea [disabled]="isFieldDisabled" kendoTextArea [(ngModel)]="option.Item[detailsPropertyName]"
                [maxlength]="1500" class="checkbox-list-textarea w-100"></textarea>
            </div>
          </div>
        </ng-container>


      </ng-container>
    </div>

    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>

  </kendo-textbox-container>
</boi-contextual-help-container>
